import { pluralize } from "@sellar-io/common";

export const generateProductItemName = (productItemProperties: {
  containerType: "can" | "bottle";
  volume: number;
  unit: string;
}) => {
  const { containerType, volume, unit } = productItemProperties;
  return `${volume}${unit} ${pluralize(containerType, 2)}`;
};
